// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"2c91abad","767":"5571a25b"}[chunkId] + ".chunk.js";
};